import React from 'react'

export default function PrivacyPolicyContent() {
  return (
    <div>
      <div className={'py-4 text-sm text-gray-500'}>
        <p>Effective date: 14/05/2024</p>
      </div>
      <div className="text-sm">
        <ul className={'flex flex-col space-y-6'}>
          <li>
            <h3 className={'pb-2 text-xl font-semibold text-gray-700'}>1. Introduction</h3>
            <div className={'flex flex-col space-y-1 pl-4'}>
              <p>
                Welcome to <b>Impressit Group Ltd trading as Asistme.ai</b>.
              </p>
              <p>
                Impressit Group Ltd trading as Asistme.ai (“us”, “we”, or “our”) operates{' '}
                <a className={'text-indigo-600 underline'} href={'https://asistme.ai'}>
                  https://asistme.ai
                </a>{' '}
                (hereinafter referred to as “<b>Service</b>”).
              </p>
              <p>
                Our Privacy Policy governs your visit to https://asistme.ai, and explains how we collect, safeguard and
                disclose information that results from your use of our Service.
              </p>
              <p>
                We use your data to provide and improve Service. By using Service, you agree to the collection and use
                of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, the
                terms used in this Privacy Policy have the same meanings as in our{' '}
                <a href={'https://asistme.ai/terms-of-service'} className={'text-indigo-600 underline'}>
                  Terms of Service
                </a>
                .
              </p>
              <p>
                Our Terms and Conditions (“Terms”) govern all use of our Service and together with the Privacy Policy
                constitutes your agreement with us (“agreement”).
              </p>
            </div>
          </li>
          <li>
            <h3 className={'pb-2 text-xl font-semibold text-gray-700'}>2. Definitions</h3>
            <div className={'flex flex-col space-y-1 pl-4'}>
              <p>
                <b>SERVICE</b> means the{' '}
                <a href={'https://asistme.ai'} className={'text-indigo-600 underline'}>
                  https://asistme.ai
                </a>{' '}
                website operated by Impressit Group Ltd trading as Asistme.ai.
              </p>

              <p>
                <b>PERSONAL DATA</b> means data about a living individual who can be identified from those data (or from
                those and other information either in our possession or likely to come into our possession).
              </p>

              <p>
                <b>USAGE DATA</b> is data collected automatically either generated by the use of Service or from Service
                infrastructure itself (for example, the duration of a page visit).
              </p>

              <p>
                <b>COOKIES</b> are small files stored on your device (computer or mobile device).
              </p>

              <p>
                <b>DATA CONTROLLER</b> means a natural or legal person who (either alone or jointly or in common with
                other persons) determines the purposes for which and the manner in which any personal data are, or are
                to be, processed. For the purpose of this Privacy Policy, we are a Data Controller of your data.
              </p>

              <p>
                <b>DATA PROCESSORS (OR SERVICE PROVIDERS)</b> means any natural or legal person who processes the data
                on behalf of the Data Controller. We may use the services of various Service Providers in order to
                process your data more effectively.
              </p>

              <p>
                <b>DATA SUBJECT</b> is any living individual who is the subject of Personal Data.
              </p>

              <p>
                <b>THE USER</b> is the individual using our Service. The User corresponds to the Data Subject, who is
                the subject of Personal Data.
              </p>
            </div>
          </li>
          <li>
            <h3 className={'pb-2 text-xl font-semibold text-gray-700'}>3. Information Collection and Use</h3>
            <div className={'flex flex-col space-y-1 pl-4'}>
              <p>
                We collect several different types of information for various purposes to provide and improve our
                Service to you.
              </p>
            </div>
          </li>
          <li>
            <h3 className={'pb-2 text-xl font-semibold text-gray-700'}>4. Types of Data Collected</h3>
            <div className={'flex flex-col space-y-1 pb-4 pl-4'}>
              <p>
                <b>Personal Data</b>
                <br />
                While using our Service, we may ask you to provide us with certain personally identifiable information
                that can be used to contact or identify you (“Personal Data”). Personally identifiable information may
                include, but is not limited to:
              </p>

              <div className={'py-4'}>
                <p>(a) Email address</p>

                <p>(b) First name and last name</p>

                <p>(c) Address, State, Province, ZIP/Postal code, City</p>

                <p>(d) Cookies and Usage Data</p>
              </div>

              <p>
                We may use your Personal Data to contact you with newsletters, marketing or promotional materials and
                other information that may be of interest to you. You may opt out of receiving any, or all, of these
                communications from us by following the unsubscribe link or by emailing at contact@asistme.ai.
              </p>
            </div>
            <div className={'flex flex-col space-y-1 pb-4 pl-4'}>
              <p>
                <b>Usage Data</b>
                <br />
                We may also collect information that your browser sends whenever you visit our Service or when you
                access Service by or through a mobile device (“<b>Usage Data</b>”).
              </p>

              <p>
                This Usage Data may include information such as your computer's Internet Protocol address (e.g. IP
                address), browser type, browser version, the pages of our Service that you visit, the time and date of
                your visit, the time spent on those pages, unique device identifiers and other diagnostic data.
              </p>

              <p>
                When you access Service with a mobile device, this Usage Data may include information such as the type
                of mobile device you use, your mobile device unique ID, the IP address of your mobile device, your
                mobile operating system, the type of mobile Internet browser you use, unique device identifiers and
                other diagnostic data.
              </p>
            </div>
            <div className={'flex flex-col space-y-1 pb-4 pl-4'}>
              <p>
                <b>Tracking Cookies Data</b>
                <br />
                We use cookies and similar tracking technologies to track the activity on our Service and we hold
                certain information.
              </p>

              <p>
                Cookies are files with a small amount of data which may include an anonymous unique identifier. Cookies
                are sent to your browser from a website and stored on your device. Other tracking technologies are also
                used such as beacons, tags and scripts to collect and track information and to improve and analyze our
                Service.
              </p>

              <p>
                You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However,
                if you do not accept cookies, you may not be able to use some portions of our Service.
              </p>

              <p>Examples of Cookies we use:</p>

              <div className={'py-4'}>
                <p>
                  (a) <b>Necessary Cookies</b>: These cookies are essential for the website's core functionality and
                  cannot be disabled within our systems. Their activation is typically triggered by user actions that
                  constitute a service request, such as configuring privacy preferences, logging in, or completing
                  forms. These cookies do not retain any personally identifiable information.
                </p>

                <p>
                  (b) <b>Session Cookies</b>: We use Session Cookies to operate our Service.
                </p>

                <p>
                  (c) <b>Preference Cookies</b>: We use Preference Cookies to remember your preferences and various
                  settings.
                </p>

                <p>
                  (d) <b>Security Cookies</b>: We use Security Cookies for security purposes.
                </p>

                <p>
                  (e) <b>Analytics Cookies</b>: These cookies permit us to quantify website visitation and traffic
                  sources. This data is instrumental in gauging and enhancing the website's performance. The information
                  gathered by these cookies is anonymized through aggregation. Should you disable these cookies, we will
                  be unable to ascertain your visitations or monitor the website's effectiveness.
                </p>

                <p>
                  (f) <b>Marketing Cookies</b>: This website utilizes marketing cookies to implement various forms of
                  targeted digital marketing initiatives. These initiatives are employed with the dual purpose of
                  enhancing your user experience and supporting the ongoing maintenance, operation, and improvement of
                  our website. Marketing cookies function by accumulating user data and behavioral information, which is
                  then leveraged by advertising services to tailor advertisements to specific audience segments based on
                  pre-defined characteristics.
                </p>

                <p>
                  (g) <b>Partners Cookies</b>: This controls whether services can use the stored data to personalize
                  ads. This includes remarketing or showing ads to users based on their previous interactions with the
                  website or app. Personalized ads are tailored to the user's interests, making them more relevant.
                </p>

                <p>
                  (h) <b>Advertising Cookies</b>: Advertising Cookies are used to serve you with advertisements that may
                  be relevant to you and your interests.
                </p>
              </div>
            </div>
          </li>
          <li>
            <h3 className={'pb-2 text-xl font-semibold text-gray-700'}>5. Lawful Basis for Processing</h3>
            <div className={'flex flex-col space-y-1 pl-4'}>
              <p>We process Personal Data based on the following lawful bases:</p>

              <p>
                (a) Consent: You have given your consent for processing Personal Data for one or more specific purposes.
              </p>

              <p>
                (b) Contract: Processing is necessary for the performance of a contract to which you are a party or in
                order to take steps at your request prior to entering into a contract.
              </p>

              <p>
                (c) Legal Obligation: Processing is necessary for compliance with a legal obligation to which we are
                subject.
              </p>

              <p>
                (d) Vital Interests: Processing is necessary to protect your vital interests or those of another natural
                person.
              </p>

              <p>
                (e) Public Task: Processing is necessary for the performance of a task carried out in the public
                interest or in the exercise of official authority vested in us.
              </p>

              <p>
                (f) Legitimate Interests: Processing is necessary for the purposes of the legitimate interests pursued
                by us or by a third party, except where such interests are overridden by your interests or fundamental
                rights and freedoms which require protection of personal data.
              </p>
            </div>
          </li>
          <li>
            <h3 className={'pb-2 text-xl font-semibold text-gray-700'}>6. Use of Data</h3>
            <div className={'flex flex-col space-y-1 pl-4'}>
              <p>Impressit Group Ltd trading as Asistme.ai uses the collected data for various purposes:</p>

              <p>(a) to provide and maintain our Service;</p>

              <p>(b) to notify you about changes to our Service;</p>

              <p>(c) to allow you to participate in interactive features of our Service when you choose to do so;</p>

              <p>(d) to provide customer support;</p>

              <p>(e) to gather analysis or valuable information so that we can improve our Service;</p>

              <p>(f) to monitor the usage of our Service;</p>

              <p>(g) to detect, prevent and address technical issues;</p>

              <p>(h) to fulfill any other purpose for which you provide it;</p>

              <p>
                (i) to carry out our obligations and enforce our rights arising from any contracts entered into between
                you and us, including for billing and collection;
              </p>

              <p>
                (j) to provide you with notices about your account and/or subscription, including expiration and renewal
                notices, email-instructions, etc.;
              </p>

              <p>
                (k) to provide you with news, special offers and general information about other goods, services and
                events which we offer that are similar to those that you have already purchased or enquired about unless
                you have opted not to receive such information;
              </p>

              <p>(l) in any other way we may describe when you provide the information;</p>

              <p>(m) for any other purpose with your consent.</p>
            </div>
          </li>
          <li>
            <h3 className={'pb-2 text-xl font-semibold text-gray-700'}>7. Retention of Data</h3>
            <div className={'flex flex-col space-y-1 pl-4'}>
              <p>
                We will retain your Personal Data only for as long as is necessary for the purposes set out in this
                Privacy Policy. We will retain and use your Personal Data to the extent necessary to comply with our
                legal obligations (for example, if we are required to retain your data to comply with applicable laws),
                resolve disputes, and enforce our legal agreements and policies.
              </p>

              <p>
                We will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a
                shorter period, except when this data is used to strengthen the security or to improve the functionality
                of our Service, or we are legally obligated to retain this data for longer time periods.
              </p>

              <p>
                In some cases it is not possible for us to specify in advance the periods for which your personal data
                will be retained. In such cases, we will determine the period of retention based on the following
                criteria:
              </p>

              <p>(a) Account information will be retained until you decide to delete your account.</p>

              <p>
                (b) Your Personal Data used for Product & Marketing communication will be retained as long as you have
                given us consent to use this information.
              </p>

              <p>
                (c) Sensitive personal information, including meeting recordings, is deleted after 6 months of
                inactivity for a given user.
              </p>

              <p>
                (d) Regardless of the provisions above, we may retain your personal data where such retention is
                necessary for compliance with a legal obligation to which we are subject, or in order to protect your
                vital interests or the vital interests of another natural person.
              </p>

              <p>
                Regardless of the provisions above, we may retain your personal data where such retention is necessary
                for compliance with a legal obligation to which we are subject, or in order to protect your vital
                interests or the vital interests of another natural person.
              </p>
            </div>
          </li>
          <li>
            <h3 className={'pb-2 text-xl font-semibold text-gray-700'}>8. Transfer of Data</h3>
            <div className={'flex flex-col space-y-1 pl-4'}>
              <p>
                Your information, including Personal Data, may be transferred to – and maintained on – computers located
                outside of your state, province, country or other governmental jurisdiction where the data protection
                laws may differ from those of your jurisdiction.
              </p>

              <p>
                If you are located outside The United Kingdom of Great Britain and Northern Ireland and choose to
                provide information to us, please note that we transfer the data, including Personal Data, to the UK and
                process it there.
              </p>

              <p>
                Your consent to this Privacy Policy followed by your submission of such information represents your
                agreement to that transfer.
              </p>

              <p>
                Impressit Group Ltd trading as Asistme.ai will take all the steps reasonably necessary to ensure that
                your data is treated securely and in accordance with this Privacy Policy and no transfer of your
                Personal Data will take place to an organisation or a country unless there are adequate controls in
                place including the security of your data and other personal information.
              </p>
            </div>
          </li>
          <li>
            <h3 className={'pb-2 text-xl font-semibold text-gray-700'}>9. Disclosure of Data.</h3>
            <div className={'flex flex-col space-y-1 pl-4'}>
              <p>We may disclose personal information that we collect, or you provide:</p>

              <div>
                <p>
                  <b>(a) Disclosure for Law Enforcement.</b>
                </p>
                <p className={'pl-4'}>
                  Under certain circumstances, we may be required to disclose your Personal Data if required to do so by
                  law or in response to valid requests by public authorities.
                </p>
              </div>

              <div>
                <p>
                  <b>(b) Business Transaction.</b>
                </p>
                <p className={'pl-4'}>
                  If we or our subsidiaries are involved in a merger, acquisition or asset sale, your Personal Data may
                  be transferred.
                </p>
              </div>

              <div>
                <p>
                  <b>(c) Other cases. We may disclose your information also:</b>
                </p>
                <div className={'pl-4'}>
                  <p>(i) to our subsidiaries and affiliates;</p>
                  <p>(ii) to contractors, service providers, and other third parties we use to support our business;</p>
                  <p>(iii) to fulfill the purpose for which you provide it;</p>
                  <p>(iv) for the purpose of including your company’s logo on our website;</p>
                  <p>(v) for any other purpose disclosed by us when you provide the information;</p>
                  <p>(vi) with your consent in any other cases;</p>
                </div>
              </div>
            </div>
          </li>
          <li>
            <h3 className={'pb-2 text-xl font-semibold text-gray-700'}>10. Security of Data</h3>
            <div className={'flex flex-col space-y-1 pl-4'}>
              <p>
                The security of your data is important to us but remember that no method of transmission over the
                Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable
                means to protect your Personal Data, we cannot guarantee its absolute security.
              </p>
            </div>
          </li>
          <li>
            <h3 className={'pb-2 text-xl font-semibold text-gray-700'}>
              11. Your Data Protection Rights Under General Data Protection Regulation (GDPR)
            </h3>
            <div className={'flex flex-col space-y-1 pl-4'}>
              <p>
                If you are a resident of the European Union (EU) and European Economic Area (EEA), you have certain data
                protection rights, covered by GDPR. – See more at{' '}
                <a className={'text-indigo-600 underline'} href={'https://eur-lex.europa.eu/eli/reg/2016/679/oj'}>
                  https://eur-lex.europa.eu/eli/reg/2016/679/oj
                </a>
              </p>
              <p>
                We aim to take reasonable steps to allow you to correct, amend, delete, or limit the use of your
                Personal Data.
              </p>
              <p>
                If you wish to be informed what Personal Data we hold about you and if you want it to be removed from
                our systems, please email us at contact@asistme.ai.
              </p>
              <p>In certain circumstances, you have the following data protection rights:</p>

              <p>(a) the right to access, update or to delete the information we have on you;</p>

              <p>
                (b) the right of rectification. You have the right to have your information rectified if that
                information is inaccurate or incomplete;
              </p>
              <p>(c) the right to object. You have the right to object to our processing of your Personal Data;</p>
              <p>
                (d) the right of restriction. You have the right to request that we restrict the processing of your
                personal information;
              </p>
              <p>
                (e) the right to data portability. You have the right to be provided with a copy of your Personal Data
                in a structured, machine-readable and commonly used format;
              </p>
              <p>
                (f) the right to withdraw consent. You also have the right to withdraw your consent at any time where we
                rely on your consent to process your personal information;
              </p>
              <p>
                Please note that we may ask you to verify your identity before responding to such requests. Please note,
                we may not able to provide Service without some necessary data.
              </p>
              <p>
                You have the right to complain to a Data Protection Authority about our collection and use of your
                Personal Data. For more information, please contact your local data protection authority in the European
                Economic Area (EEA).
              </p>
            </div>
          </li>
          <li>
            <h3 className={'pb-2 text-xl font-semibold text-gray-700'}>
              12. Your Data Protection Rights under the California Privacy Protection Act (CalOPPA)
            </h3>
            <div className={'flex flex-col space-y-1 pl-4'}>
              <p>
                CalOPPA is the first state law in the nation to require commercial websites and online services to post
                a privacy policy. The law’s reach stretches well beyond California to require a person or company in the
                United States (and conceivable the world) that operates websites collecting personally identifiable
                information from California consumers to post a conspicuous privacy policy on its website stating
                exactly the information being collected and those individuals with whom it is being shared, and to
                comply with this policy. – See more at:{' '}
                <a
                  href={
                    'https://consumercal.org/about-cfc/cfc-education-foundation/california-online-privacy-protection-act-caloppa-3/'
                  }
                  className={'text-indigo-600 underline'}
                >
                  https://consumercal.org/about-cfc/cfc-education-foundation/california-online-privacy-protection-act-caloppa-3/
                </a>
              </p>
              <p>According to CalOPPA we agree to the following:</p>
              <p>(a) users can visit our site anonymously;</p>
              <p>
                (b) our Privacy Policy link includes the word “Privacy”, and can easily be found on the page specified
                above on the home page of our website;
              </p>
              <p>(c) users will be notified of any privacy policy changes on our Privacy Policy Page;</p>
              <p>(d) users are able to change their personal information by emailing us at contact@asistme.ai.</p>
              <p>Our Policy on “Do Not Track” Signals:</p>
              <p>
                We honor Do Not Track signals and do not track, plant cookies, or use advertising when a Do Not Track
                browser mechanism is in place. Do Not Track is a preference you can set in your web browser to inform
                websites that you do not want to be tracked.
              </p>
              <p>
                You can enable or disable Do Not Track by visiting the Preferences or Settings page of your web browser.
              </p>
            </div>
          </li>
          <li>
            <h3 className={'pb-2 text-xl font-semibold text-gray-700'}>13. Service Providers</h3>
            <div className={'flex flex-col space-y-1 pl-4'}>
              <p>
                We may employ third party companies and individuals to facilitate our Service (“<b>Service Providers</b>
                ”), provide Service on our behalf, perform Service-related services or assist us in analysing how our
                Service is used.
              </p>
              <p>
                These third parties have access to your Personal Data only to perform these tasks on our behalf and are
                obligated not to disclose or use it for any other purpose.
              </p>
            </div>
          </li>
          <li>
            <h3 className={'pb-2 text-xl font-semibold text-gray-700'}>14. Analytics</h3>
            <div className={'flex flex-col space-y-1 pl-4'}>
              <p>We may use third-party Service Providers to monitor and analyze the use of our Service.</p>
              <p>
                <b>Google Analytics</b>
                <br />
                Google Analytics is a web analytics service offered by Google that tracks and reports website traffic.
                Google uses the data collected to track and monitor the use of our Service. This data is shared with
                other Google services. Google may use the collected data to contextualise and personalise the ads of its
                own advertising network.
              </p>
              <p>
                For more information on the privacy practices of Google, please visit the Google Privacy Terms web page:{' '}
                <a className={'text-indigo-600 underline'} href={'https://policies.google.com/privacy?hl=en'}>
                  https://policies.google.com/privacy?hl=en
                </a>
              </p>
              <p>
                We also encourage you to review the Google's policy for safeguarding your data:
                <a className={'text-indigo-600 underline'} href={'https://support.google.com/analytics/answer/6004245'}>
                  https://support.google.com/analytics/answer/6004245
                </a>
                .
              </p>
            </div>
          </li>
          <li>
            <h3 className={'pb-2 text-xl font-semibold text-gray-700'}>15. CI/CD tools</h3>
            <div className={'flex flex-col space-y-1 pl-4'}>
              <p>We may use third-party Service Providers to automate the development process of our Service.</p>
              <p>
                <b>GitLab CI/CD</b>
              </p>
              <p>GitLab CI/CD is provided by GitLab, Inc.</p>
              <p>
                GitLab CI (Continuous Integration) service is a part of GitLab that build and test the software whenever
                developer pushes code to application.
              </p>
              <p>
                GitLab CD (Continuous Deployment) is a software service that places the changes of every code in the
                production which results in every day deployment of production.
              </p>
              <p>
                For more information on what data GitLab CI/CD collects for what purpose and how the protection of the
                data is ensured, please visit GitLab CI/CD Privacy Policy page:{' '}
                <a href={'https://about.gitlab.com/privacy/'} className={'text-indigo-600 underline'}>
                  https://about.gitlab.com/privacy/
                </a>
                .
              </p>
            </div>
          </li>
          <li>
            <h3 className={'pb-2 text-xl font-semibold text-gray-700'}>16. Behavioral Remarketing</h3>
            <div className={'flex flex-col space-y-1 pl-4'}>
              <p>
                Impressit Group Ltd trading as Asistme.ai uses remarketing services to advertise on third party websites
                to you after you visited our Service. We and our third-party vendors use cookies to inform, optimise and
                serve ads based on your past visits to our Service.
              </p>
              <div className={'pt-4'}>
                <p>
                  <b>Google Ads (AdWords)</b>
                  <br />
                  Google Ads (AdWords) remarketing service is provided by Google Inc.
                </p>
                <p>
                  You can opt-out of Google Analytics for Display Advertising and customize the Google Display Network
                  ads by visiting the Google Ads Settings page:{' '}
                  <a href={'http://www.google.com/settings/ads'} className={'text-indigo-600 underline'}>
                    http://www.google.com/settings/ads
                  </a>
                </p>
                <p>
                  Google also recommends installing the Google Analytics Opt-out Browser Add-on –{' '}
                  <a href={'https://tools.google.com/dlpage/gaoptout'} className={'text-indigo-600 underline'}>
                    https://tools.google.com/dlpage/gaoptout
                  </a>{' '}
                  – for your web browser. Google Analytics Opt-out Browser Add-on provides visitors with the ability to
                  prevent their data from being collected and used by Google Analytics.
                </p>
                <p>
                  For more information on the privacy practices of Google, please visit the Google Privacy Terms web
                  page:
                  <a href={'https://policies.google.com/privacy?hl=en'} className={'text-indigo-600 underline'}>
                    https://policies.google.com/privacy?hl=en
                  </a>
                </p>
              </div>
              <div className={'pt-4'}>
                <p>
                  <b>Facebook</b>
                  <br />
                  Facebook remarketing service is provided by Facebook Inc.
                </p>
                <p>
                  You can learn more about interest-based advertising from Facebook by visiting this page:{' '}
                  <a href={'https://www.facebook.com/help/164968693837950'} className={'text-indigo-600 underline'}>
                    https://www.facebook.com/help/164968693837950
                  </a>
                </p>
                <p>
                  To opt-out from Facebook's interest-based ads, follow these instructions from Facebook:
                  <a href={'https://www.facebook.com/help/568137493302217'} className={'text-indigo-600 underline'}>
                    https://www.facebook.com/help/568137493302217
                  </a>
                </p>
                <p>
                  Facebook adheres to the Self-Regulatory Principles for Online Behavioural Advertising established by
                  the Digital Advertising Alliance. You can also opt-out from Facebook and other participating companies
                  through the Digital Advertising Alliance in the USA{' '}
                  <a href={'http://www.aboutads.info/choices/'} className={'text-indigo-600 underline'}>
                    http://www.aboutads.info/choices/
                  </a>
                  , the Digital Advertising Alliance of Canada in Canada
                  <a href={'http://youradchoices.ca/'} className={'text-indigo-600 underline'}>
                    http://youradchoices.ca/
                  </a>{' '}
                  or the European Interactive Digital Advertising Alliance in Europe{' '}
                  <a href={'http://www.youronlinechoices.eu/'} className={'text-indigo-600 underline'}>
                    http://www.youronlinechoices.eu/
                  </a>
                  , or opt-out using your mobile device settings.
                  <a href={'https://www.facebook.com/help/568137493302217'} className={'text-indigo-600 underline'}>
                    https://www.facebook.com/help/568137493302217
                  </a>
                </p>
                <p>
                  For more information on the privacy practices of Facebook, please visit Facebook's Data Policy:{' '}
                  <a href={'https://www.facebook.com/privacy/explanation'} className={'text-indigo-600 underline'}>
                    https://www.facebook.com/privacy/explanation
                  </a>
                </p>
              </div>
            </div>
          </li>
          <li>
            <h3 className={'pb-2 text-xl font-semibold text-gray-700'}>17. Payments</h3>
            <div className={'flex flex-col space-y-1 pl-4'}>
              <p>
                We may provide paid products and/or services within Service. In that case, we use third-party services
                for payment processing (e.g. payment processors).
              </p>
              <p>
                We will not store or collect your payment card details. That information is provided directly to our
                third-party payment processors whose use of your personal information is governed by their Privacy
                Policy. These payment processors adhere to the standards set by PCI-DSS as managed by the PCI Security
                Standards Council, which is a joint effort of brands like Visa, Mastercard, American Express and
                Discover. PCI-DSS requirements help ensure the secure handling of payment information.
              </p>
              <p>The payment processors we work with are:</p>
              <p>
                <b>Stripe:</b>
                <br />
                Their Privacy Policy can be viewed at:{' '}
                <a href={'https://stripe.com/us/privacy'} className={'text-indigo-600 underline'}>
                  https://stripe.com/us/privacy
                </a>
              </p>
            </div>
          </li>
          <li>
            <h3 className={'pb-2 text-xl font-semibold text-gray-700'}>18. Links to Other Sites</h3>
            <div className={'flex flex-col space-y-1 pl-4'}>
              <p>
                Our Service may contain links to other sites that are not operated by us. If you click a third party
                link, you will be directed to that third party's site. We strongly advise you to review the Privacy
                Policy of every site you visit.
              </p>
              <p>
                We have no control over and assume no responsibility for the content, privacy policies or practices of
                any third party sites or services.
              </p>
            </div>
          </li>
          <li>
            <h3 className={'pb-2 text-xl font-semibold text-gray-700'}>19. Children's Privacy</h3>
            <div className={'flex flex-col space-y-1 pl-4'}>
              <p>
                Our Services are not intended for use by children under the age of 18 (“<b>Child</b>” or “
                <b>Children</b>”).
              </p>
              <p>
                We do not knowingly collect personally identifiable information from Children under 18. If you become
                aware that a Child has provided us with Personal Data, please contact us. If we become aware that we
                have collected Personal Data from Children without verification of parental consent, we take steps to
                remove that information from our servers.
              </p>
            </div>
          </li>
          <li>
            <h3 className={'pb-2 text-xl font-semibold text-gray-700'}>20. Changes to This Privacy Policy</h3>
            <div className={'flex flex-col space-y-1 pl-4'}>
              <p>
                We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new
                Privacy Policy on this page.
              </p>
              <p>
                We will let you know via email and/or a prominent notice on our Service, prior to the change becoming
                effective and update “effective date” at the top of this Privacy Policy.
              </p>
              <p>
                You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy
                Policy are effective when they are posted on this page.
              </p>
            </div>
          </li>
          <li>
            <h3 className={'pb-2 text-xl font-semibold text-gray-700'}>21. Data Protection Officer (DPO)</h3>
            <div className={'flex flex-col space-y-1 pl-4'}>
              <p>
                We have appointed a Data Protection Officer (DPO) to oversee our company's compliance with data
                protection laws and regulations. You may contact our DPO using the following details:
              </p>
              <p>Name of DPO: Andrii Lekh</p>
              <p>Email: alekh@impressit.io</p>
              <p>Phone number: +380933217708</p>
              <p>
                If you have any questions or concerns regarding our Privacy Policy or the processing of your personal
                data, including the exercising of your rights as detailed in this Privacy Policy, you may contact our
                DPO directly or reach out to Customer Support at contact@asistme.ai.
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  )
}
